/** Picks v2 or v1 of the Role create/edit form based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import RoleFormPage   from './RoleFormPage';
import RoleFormPageV2 from './v2/RoleFormPageV2';

export default function RoleFormPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? RoleFormPageV2 : RoleFormPage;
  return <Component {...props} />;
}
